import React, { useCallback } from 'react';
import { Highlight } from './styles';
import { useDocumentContext, COMPLEX_DOCUMENT_CONTEXT_KEYS } from '../../context/complexDocumentContext';

const BlockHighlight = ({ pageUUID }) => {
  const customSelector = useCallback((store) => store[pageUUID], []);
  const [pageDetails] = useDocumentContext(customSelector, `BlockHighlight-${pageUUID}`);

  const emailSelector = useCallback((store) => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.IS_EMAIL_TEMPLATE], []);
  const [isEmailTemplate] = useDocumentContext(emailSelector, `BlockHighlight-${pageUUID}`);

  return (
    <Highlight id="BlockHighlight" background={isEmailTemplate ? pageDetails?.color : pageDetails?.backgroundColor} />
  )
}

export default BlockHighlight;
